"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var OpacityField_1 = __importDefault(require("../Field/OpacityField/OpacityField"));
var ImageField_1 = __importDefault(require("../Field/ImageField/ImageField"));
var _cloneDeep = require('lodash/cloneDeep');
var _isEmpty = require('lodash/isEmpty');
var _isEqual = require('lodash/isEqual');
var RotateField_1 = __importDefault(require("../Field/RotateField/RotateField"));
var SizeField_1 = __importDefault(require("../Field/SizeField/SizeField"));
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var antd_1 = require("antd");
var CompositionContext_1 = require("../../CompositionContext/CompositionContext");
var CompositionUtil_1 = __importDefault(require("../../../Util/CompositionUtil"));
var IconEditor = /** @class */ (function (_super) {
    __extends(IconEditor, _super);
    function IconEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onImageSrcChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.image = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onSizeChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.size = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onRotateChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.rotate = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOpacityChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.opacity = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        /**
         * Wraps a Form Item around a given element and adds its locale
         * to the From Item label.
         */
        _this.wrapFormItem = function (locale, element) {
            var formItemLayout = {
                labelCol: { span: 8 },
                wrapperCol: { span: 16 }
            };
            return element == null ? null : (React.createElement(antd_1.Form.Item, __assign({ label: locale }, formItemLayout), element));
        };
        return _this;
    }
    IconEditor.prototype.shouldComponentUpdate = function (nextProps) {
        var diffProps = !_isEqual(this.props, nextProps);
        return diffProps;
    };
    IconEditor.prototype.render = function () {
        var _this = this;
        var locale = this.props.locale;
        var _a = this.props, symbolizer = _a.symbolizer, iconLibraries = _a.iconLibraries;
        var opacity = symbolizer.opacity, image = symbolizer.image, size = symbolizer.size, rotate = symbolizer.rotate;
        var imageSrc = !_isEmpty(image) ? image : 'URL to Icon';
        return (React.createElement(CompositionContext_1.CompositionContext.Consumer, null, function (composition) { return (React.createElement("div", { className: "gs-icon-symbolizer-editor" },
            _this.wrapFormItem(locale.imageLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'IconEditor.imageField',
                onChange: _this.onImageSrcChange,
                propName: 'value',
                propValue: imageSrc,
                defaultElement: (React.createElement(ImageField_1.default, { iconLibraries: iconLibraries, tooltipLabel: locale.iconTooltipLabel }))
            })),
            _this.wrapFormItem(locale.sizeLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'IconEditor.sizeField',
                onChange: _this.onSizeChange,
                propName: 'size',
                propValue: size,
                defaultElement: React.createElement(SizeField_1.default, null)
            })),
            _this.wrapFormItem(locale.rotateLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'IconEditor.rotateField',
                onChange: _this.onRotateChange,
                propName: 'rotate',
                propValue: rotate,
                defaultElement: React.createElement(RotateField_1.default, null)
            })),
            _this.wrapFormItem(locale.opacityLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'IconEditor.opacityField',
                onChange: _this.onOpacityChange,
                propName: 'opacity',
                propValue: opacity,
                defaultElement: React.createElement(OpacityField_1.default, null)
            })))); }));
    };
    IconEditor.defaultProps = {
        locale: en_US_1.default.GsIconEditor
    };
    IconEditor.componentName = 'IconEditor';
    return IconEditor;
}(React.Component));
exports.IconEditor = IconEditor;
exports.default = LocaleWrapper_1.localize(IconEditor, IconEditor.componentName);
//# sourceMappingURL=IconEditor.js.map